'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_Ljava_time_DateTimeException__T__jl_Throwable__($thiz, message, cause) {
  $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz;
}
export { $ct_Ljava_time_DateTimeException__T__jl_Throwable__ as $ct_Ljava_time_DateTimeException__T__jl_Throwable__ };
function $ct_Ljava_time_DateTimeException__T__($thiz, message) {
  $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, null, true, true);
  return $thiz;
}
export { $ct_Ljava_time_DateTimeException__T__ as $ct_Ljava_time_DateTimeException__T__ };
class $c_Ljava_time_DateTimeException extends $j_java$002elang$002e$002dObject.$c_jl_RuntimeException {
}
export { $c_Ljava_time_DateTimeException as $c_Ljava_time_DateTimeException };
function $isArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bP)));
}
export { $isArrayOf_Ljava_time_DateTimeException as $isArrayOf_Ljava_time_DateTimeException };
var $d_Ljava_time_DateTimeException = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DateTimeException, "java.time.DateTimeException", ({
  bP: 1,
  R: 1,
  Q: 1,
  H: 1,
  a: 1
}));
export { $d_Ljava_time_DateTimeException as $d_Ljava_time_DateTimeException };
